import React from 'react'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import Modal from 'LuxKit/Modal/Modal'
import OfferAirportOptions from '../../Airport/OfferAirportOptions'

function OfferCalendarAirportModal() {
  const { resolve } = useModalElementContext<App.AirportLocation | undefined>()

  return <Modal
    title="Where will you depart from?"
    subtitle="Select your preferred airport"
    height="max"
    primaryActionText="Apply"
  >
    <OfferAirportOptions onSelectAirport={resolve} />
  </Modal>
}

export default OfferCalendarAirportModal
